import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
// import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { Accordion, AccordionTab } from "primereact/accordion";
import { states, stateWithCity } from "../model";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";

// ─── Constants (Monster RSX values) ──────────────────────────────────────────

const EDUCATION_LEVELS = [
  { label: "Any", value: "" },
  { label: "High School or Equivalent", value: "1" },
  { label: "Certification", value: "2" },
  { label: "Vocational", value: "3" },
  { label: "Associate Degree", value: "4" },
  { label: "Bachelor's Degree", value: "5" },
  { label: "Master's Degree", value: "6" },
  { label: "Doctorate", value: "7" },
  { label: "Professional", value: "8" },
  { label: "Some College Coursework", value: "9" },
  { label: "Vocational HS Diploma", value: "10" },
  { label: "Some High School", value: "11" },
];

const WORK_AUTH_OPTIONS = [
  { label: "Any", value: "" },
  { label: "Authorized to work for any employer", value: "1" },
  { label: "Authorized for current employer only", value: "2" },
  { label: "Requires Sponsorship", value: "3" },
];

const RELOCATION_OPTIONS = [
  { label: "Any", value: "" },
  { label: "Will Relocate", value: "1" },
  { label: "Won't Relocate", value: "0" },
];

const RESUME_UPDATED_OPTIONS = [
  { label: "Any Time", value: "" },
  { label: "Last 1 Day", value: "1" },
  { label: "Last 7 Days", value: "7" },
  { label: "Last 14 Days", value: "14" },
  { label: "Last 30 Days", value: "30" },
  { label: "Last 3 Months", value: "90" },
  { label: "Within 6 Months", value: "180" },
  { label: "Within 9 Months", value: "270" },
  { label: "Within 12 Months", value: "360" },
  { label: "Within 36 Months", value: "1080" },
  { label: "Custom Range", value: "custom" },
];

const RADIUS_OPTIONS = [
  { label: "Exact Location", value: "5" },
  { label: "Within 10 miles", value: "10" },
  { label: "Within 15 miles", value: "15" },
  { label: "Within 20 miles", value: "20" },
  { label: "Within 25 miles", value: "25" },
  { label: "Within 30 miles", value: "30" },
  { label: "Within 35 miles", value: "35" },
  { label: "Within 40 miles", value: "40" },
  { label: "Within 45 miles", value: "45" },
  { label: "Within 50 miles", value: "50" },
  { label: "Within 100 miles", value: "100" },
];

// const SALARY_TYPE_OPTIONS = [
//   { label: "Any", value: "" },
//   { label: "Per Year", value: "1" },
//   { label: "Per Hour", value: "2" },
// ];

const MILITARY_OPTIONS = [
  { label: "Any", value: "" },
  { label: "Active Duty", value: "2" },
  { label: "Veteran/Prior Service", value: "4" },
  { label: "Reservist", value: "5" },
  { label: "Any Military Background", value: "1" },
];

const JOB_TYPE_OPTIONS = [
  { label: "Permanent", key: "tjtp" },
  { label: "Temp/Contract", key: "tjttc" },
  { label: "Full Time", key: "tjtft" },
  { label: "Part Time", key: "tjtpt" },
  { label: "Intern", key: "tjti" },
  { label: "Per Diem", key: "tjtpd" },
  { label: "Seasonal", key: "tjts" },
];

const SECURITY_CLEARANCE_OPTIONS = [
  { label: "None", value: "11" },
  { label: "Active Confidential", value: "12" },
  { label: "Active Secret", value: "13" },
  { label: "Active Top Secret", value: "14" },
  { label: "Inactive Confidential", value: "15" },
  { label: "Inactive Secret", value: "16" },
  { label: "Inactive Top Secret", value: "17" },
];

// { label: "Active Top Secret/SCI", value: "6" },
// { label: "Active TS/SCI-CI Polygraph", value: "19" },
// { label: "Active TS/SCI-FS Polygraph", value: "20" },
// { label: "Other Active Clearance", value: "21" },

// ─── Default filter state ─────────────────────────────────────────────────────

const DEFAULT_FILTERS = {
  // Search Keywords
  location: [] as any[],
  jobTitle: "",
  radius: "",
  skillKeywords: "",

  // Resume Dates
  resumeUpdatedRange: "",
  resumeUpdatedFrom: null,
  resumeUpdatedTo: null,

  // Candidate Preferences
  relocation: "",
  workAuth: "",
  educationLevel: "",

  // Experience
  mostRecentEmployer: "",
  mostRecentJobTitle: "",
  mostRecentJobDescription: "",

  // Education
  schoolAttended: "",

  // Salary
  salaryMin: "",
  salaryMax: "",
  salaryType: "",

  // Military
  militaryExperience: "",

  // Experience Range
  experienceRange: "",

  //Education Major
  educationMajors: [] as string[],

  //Exclude Keyword
  excludeKeywords: [] as string[],

  //Job Type
  jobTypes: [] as string[],

  //Security Clearance
  securityClearance: [] as string[],
};

// ─── Field Wrapper ────────────────────────────────────────────────────────────

export const FieldWrapper = ({ label, error, children }: any) => (
  <div style={{ marginBottom: "12px" }}>
    {label && <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#374151", marginBottom: "4px", letterSpacing: "0.03em" }}>{label}</label>}
    {children}
    {error && (
      <span style={{ fontSize: "10px", color: "#dc2626", marginTop: "2px", display: "block" }}>
        <i className="pi pi-exclamation-circle" style={{ marginRight: 3 }} />
        {error}
      </span>
    )}
  </div>
);

// ─── Shared input style ───────────────────────────────────────────────────────

export const inputStyle = { width: "100%", fontSize: "12px", borderRadius: "6px", border: "1px solid #d1d5db", padding: "6px 10px", color: "#111827", background: "#fff" };

// ─── Main Filter Component ────────────────────────────────────────────────────

export const MonsterBooleanSearchFilter = ({ collapsed, onToggleCollapse, onNewSearch, onClear, booleanSearchQuery, onApply, resetKey = 0 }: any) => {
  const [filters, setFilters] = useState({ ...DEFAULT_FILTERS, skillKeywords: booleanSearchQuery || "" });
  const [errors, setErrors] = useState({} as any);
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [manualZip, setManualZip] = useState("");
  const [manualMajor, setManualMajor] = useState("");
  const [manualExclude, setManualExclude] = useState("");
  const locationInputRef = useRef<HTMLInputElement>(null);

  const searchLocation = (event: { query: string }) => {
    const query = event.query.trim().toLowerCase();

    if (!query) {
      setSuggestions([]);
      return;
    }

    const results: any[] = [];

    // 1. State suggestions
    states
      .filter((s) => s.name.toLowerCase().includes(query))
      .forEach((s) => {
        results.push({ City: "", State: s.name, Type: "State", label: s.name });
      });

    // 2. City suggestions
    stateWithCity
      .filter((item: any) => {
        const city = (item.City ?? "").toLowerCase();
        const state = (item.State ?? "").toLowerCase();

        return city.includes(query) || state.includes(query);
      })
      .forEach((item: any) => {
        results.push({
          ...item,
          Type: "City",
          label: `${item.City}, ${item.State}`,
        });
      });

    setSuggestions(results.slice(0, 50));
  };

  const handleLocationSelect = async (e: any) => {
    const selected = e.value;

    if (selected?.Type !== "City") return;

    try {
      const response = await fetch(`https://api.zippopotam.us/us/${encodeURIComponent(selected.State)}/${encodeURIComponent(selected.City)}`);

      if (!response.ok) return;

      const data = await response.json();

      const zipCode = data?.places?.[0]?.["post code"]?.trim();

      setFilters((prev) => ({
        ...prev,
        location: prev.location.map((item: any) => (item?.City === selected.City && item?.State === selected.State ? { ...item, zipCode } : item)),
      }));
    } catch (error) {
      console.error("Failed to resolve ZIP:", error);
    }
  };

  useEffect(() => {
    const inputEl = locationInputRef.current;
    if (!inputEl) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== "Enter") return;

      const hasHighlighted = document.querySelector(".p-autocomplete-item.p-highlight");
      if (hasHighlighted) return;

      const raw = inputEl.value.trim();
      if (!raw) return;

      const looksLikeZip = /^\d{4,10}(-\d{4})?$/.test(raw);
      if (!looksLikeZip) return;

      // Stop PrimeReact's own handler from running / doing anything with this Enter
      e.preventDefault();
      e.stopPropagation();

      const newItem = { City: "", State: "", zipCode: raw, Type: "Zip", label: raw };

      setFilters((prev) => ({ ...prev, location: [...prev.location, newItem] }));
      // console.log("[manual zip added]", newItem);
      inputEl.value = "";
      setSuggestions([]);
    };

    // capture: true = runs before PrimeReact's bubble-phase listener, always
    inputEl.addEventListener("keydown", handleKeyDown, true);
    return () => inputEl.removeEventListener("keydown", handleKeyDown, true);
  }, []);

  const addManualZip = () => {
    const raw = manualZip.trim();
    if (!raw) return;

    const looksLikeZip = /^\d{4,10}(-\d{4})?$/.test(raw);
    if (!looksLikeZip) {
      // optional: surface a small inline error instead of silently ignoring
      return;
    }

    const newItem = { City: "", State: "", zipCode: raw, Type: "Zip", label: raw };

    setFilters((prev) => ({
      ...prev,
      location: [...prev.location, newItem],
    }));

    // console.log("[manual zip added]", newItem);
    setManualZip("");
  };

  // Reset when resetKey changes
  useEffect(() => {
    setFilters({ ...DEFAULT_FILTERS });
    setErrors({});
  }, [resetKey]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      skillKeywords: booleanSearchQuery || "",
    }));
  }, [booleanSearchQuery]);

  const set = (key: any, value: any) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    if ((errors as any)[key]) setErrors((prev: any) => ({ ...prev, [key]: undefined }));
  };

  // ── Validation ──────────────────────────────────────────────────────────────
  const validate = () => {
    const errs = {} as any;

    if (filters.resumeUpdatedRange === "custom" && !filters.resumeUpdatedFrom) {
      errs.resumeUpdatedFrom = "From date is required";
    }

    if (filters.salaryMin && filters.salaryMax) {
      if (Number(filters.salaryMin) > Number(filters.salaryMax)) {
        errs.salaryMax = "Max salary must be greater than Min salary";
      }
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const normalizeLocations = (locations: any[], radius: string) =>
    locations.map((loc) => ({
      city: loc?.City || "",
      state: (loc?.State ?? "").trim().toUpperCase(),
      postalCode: loc?.zipCode || undefined,
      radius: radius ? Number(radius) : 30,
      radiusUnit: "Miles",
    }));

  // Monster's bracket definitions, as [minYears, maxYears] — maxYears = Infinity for open-ended
  const EXP_BRACKETS: { id: number; min: number; max: number }[] = [
    { id: 1, min: 0, max: 1 },
    { id: 2, min: 1, max: 2 },
    { id: 3, min: 2, max: 5 },
    { id: 4, min: 5, max: 7 },
    { id: 5, min: 7, max: 10 },
    { id: 6, min: 10, max: 15 },
    { id: 7, min: 15, max: Infinity },
  ];

  // Range token (e.g. "2-5"): match brackets using half-open overlap so touching
  // endpoints don't spuriously pull in the neighboring bracket.
  // (2,5] vs (1,2] → no overlap (2 belongs only to the lower bracket)

  // (2,5] vs (5,7] → no overlap (5 belongs only to the upper bracket... i.e. THIS one)
  const bracketsInRange = (lo: number, hi: number) => EXP_BRACKETS.filter((b) => b.min < hi && lo < b.max).map((b) => b.id);

  // Exact single value (e.g. "4"): find the one bracket that contains it
  const bracketsForExact = (val: number) => EXP_BRACKETS.filter((b) => (b.min === 0 ? val <= b.max : b.min < val && val <= b.max)).map((b) => b.id);

  // "<N": any bracket that starts before N (captures partial overlap too)
  const bracketsBelow = (n: number) => EXP_BRACKETS.filter((b) => b.min < n).map((b) => b.id);

  // "N+": any bracket that extends beyond N (excludes brackets that end exactly at N)
  const bracketsAbove = (n: number) => EXP_BRACKETS.filter((b) => b.max > n).map((b) => b.id);

  const parseExperienceRange = (input: string): string => {
    if (!input?.trim()) return "";

    const ids = new Set<number>();

    input
      .split(",")
      .map((tok) => tok.trim())
      .filter(Boolean)
      .forEach((tok) => {
        if (tok.startsWith("<")) {
          const n = Number(tok.slice(1));
          if (!Number.isNaN(n)) bracketsBelow(n).forEach((id) => ids.add(id));
        } else if (tok.endsWith("+")) {
          const n = Number(tok.slice(0, -1));
          if (!Number.isNaN(n)) bracketsAbove(n).forEach((id) => ids.add(id));
        } else if (tok.includes("-")) {
          const [a, b] = tok.split("-").map(Number);
          if (!Number.isNaN(a) && !Number.isNaN(b)) {
            bracketsInRange(Math.min(a, b), Math.max(a, b)).forEach((id) => ids.add(id));
          }
        } else {
          const n = Number(tok);
          if (!Number.isNaN(n)) bracketsForExact(n).forEach((id) => ids.add(id));
        }
      });

    return Array.from(ids)
      .sort((a, b) => a - b)
      .join(",");
  };

  const addEducationMajor = () => {
    const raw = manualMajor.trim();
    if (!raw) return;
    if (filters.educationMajors.includes(raw)) {
      setManualMajor("");
      return;
    }

    setFilters((prev) => {
      const next = { ...prev, educationMajors: [...prev.educationMajors, raw] };
      return next;
    });
    setManualMajor("");
  };

  const removeEducationMajor = (major: string) => {
    setFilters((prev) => ({
      ...prev,
      educationMajors: prev.educationMajors.filter((m) => m !== major),
    }));
  };

  const addExcludeKeyword = () => {
    const raw = manualExclude.trim();
    if (!raw) return;
    if (filters.excludeKeywords.includes(raw)) {
      setManualExclude("");
      return;
    }

    setFilters((prev) => ({
      ...prev,
      excludeKeywords: [...prev.excludeKeywords, raw],
    }));
    setManualExclude("");
  };

  const removeExcludeKeyword = (kw: string) => {
    setFilters((prev) => ({
      ...prev,
      excludeKeywords: prev.excludeKeywords.filter((k) => k !== kw),
    }));
  };

  const toggleJobType = (key: string) => {
    setFilters((prev) => ({
      ...prev,
      jobTypes: prev.jobTypes.includes(key) ? prev.jobTypes.filter((k) => k !== key) : [...prev.jobTypes, key],
    }));
  };

  const toggleSecurityClearance = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      securityClearance: prev.securityClearance.includes(value) ? prev.securityClearance.filter((v) => v !== value) : [...prev.securityClearance, value],
    }));
  };

  const handleApply = () => {
    if (validate()) {
      onApply &&
        onApply({
          ...filters,
          locations: normalizeLocations(filters.location, filters.radius),
          yrsexpid: parseExperienceRange(filters.experienceRange),
          educationMajors: filters.educationMajors,
        });
    }
  };

  const handleClear = () => {
    setFilters({ ...DEFAULT_FILTERS });
    setErrors({});
    onClear && onClear();
  };

  // ── Collapsed state ─────────────────────────────────────────────────────────
  if (collapsed) {
    return (
      <div
        style={{
          width: "32px",
          display: "flex",
          alignItems: "flex-start",
          paddingTop: "12px",
          borderRight: "1px solid #e5e7eb",
          backgroundColor: "#fff",
          flexShrink: 0,
          height: "100vh",
        }}
      >
        <Button icon="pi pi-chevron-right" className="p-button-text p-button-sm p-0" style={{ color: "#6b7280", width: "32px" }} onClick={onToggleCollapse} tooltip="Expand filters" tooltipOptions={{ position: "right" }} />
      </div>
    );
  }

  // ── Expanded state ──────────────────────────────────────────────────────────
  return (
    <div
      style={{
        width: "310px",
        minWidth: "310px",
        borderRight: "1px solid #e5e7eb",
        backgroundColor: "#fff",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        transition: "width 0.25s ease",
      }}
    >
      {/* ── Header ────────────────────────────────────────────────────────── */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          borderBottom: "1px solid #e5e7eb",
          background: "linear-gradient(135deg, #f5f0ff, #faf8ff)",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <i className="pi pi-sliders-h" style={{ color: "#9333ea", fontSize: "14px" }} />
          <span style={{ fontSize: "13px", fontWeight: 700, color: "#4b0082" }}>Refine Search</span>
        </div>
        <Button icon="pi pi-chevron-left" className="p-button-text p-button-sm p-0" style={{ color: "#6b7280" }} onClick={onToggleCollapse} />
      </div>

      {/* ── Scrollable Body ────────────────────────────────────────────────── */}
      <div style={{ flex: 1, overflowY: "auto", padding: "0 0 12px 0" }}>
        <Accordion multiple activeIndex={[0]}>
          {/* ── 1. Keywords & Location ───────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-search" style={{ marginRight: 6, color: "#9333ea" }} />
                Keywords & Location
              </span>
            }
          >
            <FieldWrapper label="Job Title">
              <InputText value={filters.jobTitle} onChange={(e) => set("jobTitle", e.target.value)} placeholder="e.g. Software Engineer" style={inputStyle} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Location (City, State, or ZIP)">
              <AutoComplete
                value={filters.location}
                suggestions={suggestions}
                completeMethod={searchLocation}
                field="label"
                multiple
                onSelect={handleLocationSelect}
                forceSelection={false}
                selectedItemTemplate={(item: any) => (item.Type === "State" ? item.State : item.label || item)}
                onChange={(e) => {
                  const value = (e.value || []).map((item: any) => {
                    if (typeof item === "string") {
                      return { City: "", State: "", zipCode: item.trim(), Type: "Zip", label: item.trim() };
                    }
                    return item;
                  });
                  set("location", value);
                }}
                itemTemplate={(item: any) => <div style={{ fontSize: "12px" }}>{item.Type === "State" ? <strong>{item.State}</strong> : <strong>{item.label}</strong>}</div>}
                placeholder="Search City, State"
                style={{ width: "100%" }}
                inputStyle={{ ...inputStyle, width: "100%", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: "none" }}
              />

              <div style={{ display: "flex" }}>
                <InputText
                  value={manualZip}
                  onChange={(e) => setManualZip(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addManualZip();
                    }
                  }}
                  placeholder="Or type a ZIP and press Enter"
                  style={{ ...inputStyle, flex: 1, borderTopLeftRadius: 0, borderTopRightRadius: 0, fontSize: "11px" }}
                />
                <Button icon="pi pi-plus" className="p-button-sm" onClick={addManualZip} style={{ backgroundColor: "#374151", border: "none", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }} />
              </div>
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Search Radius">
              <Dropdown value={filters.radius} options={RADIUS_OPTIONS} onChange={(e) => set("radius", e.value)} placeholder="Select radius" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Skill Keywords">
              <InputText value={filters.skillKeywords} onChange={(e) => set("skillKeywords", e.target.value)} placeholder="e.g. React, Python, SQL" style={inputStyle} />
              <span style={{ fontSize: "10px", color: "#9ca3af", marginTop: 2, display: "block" }}>Comma or space separated</span>
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Exclude Keywords">
              <div style={{ display: "flex" }}>
                <InputText
                  value={manualExclude}
                  onChange={(e) => setManualExclude(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addExcludeKeyword();
                    }
                  }}
                  placeholder="e.g. Anesthesiology, Java Apache "
                  style={{ ...inputStyle, flex: 1, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                />
                <Button type="button" icon="pi pi-plus" className="p-button-sm" onClick={addExcludeKeyword} style={{ backgroundColor: "#374151", border: "none", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} />
              </div>

              {filters.excludeKeywords.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "8px" }}>
                  {filters.excludeKeywords.map((kw) => (
                    <span key={kw} style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", background: "#fee2e2", color: "#991b1b", padding: "3px 8px", borderRadius: "12px" }}>
                      {kw}
                      <i className="pi pi-times" style={{ fontSize: "9px", cursor: "pointer" }} onClick={() => removeExcludeKeyword(kw)} />
                    </span>
                  ))}
                </div>
              )}
              <span style={{ fontSize: "10px", color: "#6b7280", marginTop: "5px", display: "block" }}>
                <i className="pi pi-info-circle" style={{ marginRight: "4px" }} /> Press <strong>Enter</strong> or click <strong>+</strong> to add the keyword before updating.{" "}
              </span>

              <span style={{ fontSize: "10px", color: "#9ca3af", marginTop: 4, display: "block" }}>Resumes containing these will be excluded</span>
            </FieldWrapper>
          </AccordionTab>

          {/* ── 2. Resume Updated ────────────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-calendar" style={{ marginRight: 6, color: "#9333ea" }} />
                Resume Updated
              </span>
            }
          >
            <FieldWrapper label="Updated Within">
              <Dropdown value={filters.resumeUpdatedRange} options={RESUME_UPDATED_OPTIONS} onChange={(e) => set("resumeUpdatedRange", e.value)} placeholder="Any time" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>

            {filters.resumeUpdatedRange === "custom" && (
              <>
                <FieldWrapper label="Updated Since (From Date)" error={errors.resumeUpdatedFrom}>
                  <Calendar value={filters.resumeUpdatedFrom} onChange={(e) => set("resumeUpdatedFrom", e.value)} placeholder="MM/DD/YYYY" showIcon dateFormat="mm/dd/yy" maxDate={filters.resumeUpdatedTo || new Date()} inputStyle={{ ...inputStyle, width: "100%" }} style={{ width: "100%" }} />
                </FieldWrapper>
              </>
            )}
          </AccordionTab>

          {/* ── 3. Candidate Preferences ─────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-user" style={{ marginRight: 6, color: "#9333ea" }} />
                Candidate Preferences
              </span>
            }
          >
            <FieldWrapper label="Relocation">
              <Dropdown value={filters.relocation} options={RELOCATION_OPTIONS} onChange={(e) => set("relocation", e.value)} placeholder="Any" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Work Authorization">
              <Dropdown value={filters.workAuth} options={WORK_AUTH_OPTIONS} onChange={(e) => set("workAuth", e.value)} placeholder="Any" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Years of Experience">
              <InputText value={filters.experienceRange} onChange={(e) => set("experienceRange", e.target.value)} placeholder="e.g. 4, 2-3, 5+, <8" style={inputStyle} />
              <span style={{ fontSize: "10px", color: "#9ca3af", marginTop: 2, display: "block" }}>Comma-separated: exact (4), range (2-3), min (5+), max (&lt;8)</span>
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Military Status">
              <Dropdown value={filters.militaryExperience} options={MILITARY_OPTIONS} onChange={(e) => set("militaryExperience", e.value)} placeholder="Any" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Target Job Type">
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                {JOB_TYPE_OPTIONS.map((opt) => (
                  <div key={opt.key} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Checkbox inputId={opt.key} checked={filters.jobTypes.includes(opt.key)} onChange={() => toggleJobType(opt.key)} />
                    <label htmlFor={opt.key} style={{ fontSize: "12px", color: "#374151", cursor: "pointer" }}>
                      {opt.label}
                    </label>
                  </div>
                ))}
              </div>
            </FieldWrapper>
          </AccordionTab>

          {/* ──4. Security Clearance ───────────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-shield" style={{ marginRight: 6, color: "#9333ea" }} />
                Security Clearance
              </span>
            }
          >
            <FieldWrapper label="">
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                {SECURITY_CLEARANCE_OPTIONS.map((opt) => (
                  <div key={opt.value} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Checkbox inputId={`gsc-${opt.value}`} checked={filters.securityClearance.includes(opt.value)} onChange={() => toggleSecurityClearance(opt.value)} />
                    <label htmlFor={`gsc-${opt.value}`} style={{ fontSize: "12px", color: "#374151", cursor: "pointer" }}>
                      {opt.label}
                    </label>
                  </div>
                ))}
              </div>
            </FieldWrapper>
          </AccordionTab>

          {/* ── 5. Most Recent Experience ─────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-briefcase" style={{ marginRight: 6, color: "#9333ea" }} />
                Most Recent Experience
              </span>
            }
          >
            <FieldWrapper label="Most Recent Employer">
              <InputText value={filters.mostRecentEmployer} onChange={(e) => set("mostRecentEmployer", e.target.value)} placeholder="e.g. Google, Amazon" style={inputStyle} />
            </FieldWrapper>

            <FieldWrapper label="Most Recent Job Title">
              <InputText value={filters.mostRecentJobTitle} onChange={(e) => set("mostRecentJobTitle", e.target.value)} placeholder="e.g. Senior Developer" style={inputStyle} />
            </FieldWrapper>

            <FieldWrapper label="Most Recent Job Description">
              <textarea value={filters.mostRecentJobDescription} onChange={(e) => set("mostRecentJobDescription", e.target.value)} placeholder="Keywords from job description..." rows={3} style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit", lineHeight: "1.5" }} />
            </FieldWrapper>
          </AccordionTab>

          {/* ── 5. Education ─────────────────────────────────────────────── */}
          <AccordionTab
            header={
              <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                <i className="pi pi-book" style={{ marginRight: 6, color: "#9333ea" }} />
                Education
              </span>
            }
          >
            <FieldWrapper label="School Attended">
              <InputText value={filters.schoolAttended} onChange={(e) => set("schoolAttended", e.target.value)} placeholder="e.g. MIT, Stanford" style={inputStyle} />
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Degree/Major">
              <div style={{ display: "flex" }}>
                <InputText
                  value={manualMajor}
                  onChange={(e) => setManualMajor(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addEducationMajor();
                    }
                  }}
                  placeholder="e.g. Computer Engineering"
                  style={{ ...inputStyle, flex: 1, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                />
                <Button type="button" icon="pi pi-plus" className="p-button-sm" onClick={addEducationMajor} style={{ backgroundColor: "#374151", border: "none", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} />
              </div>

              {filters.educationMajors.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "8px" }}>
                  {filters.educationMajors.map((major) => (
                    <span key={major} style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", background: "#f3e8ff", color: "#6b21a8", padding: "3px 8px", borderRadius: "12px" }}>
                      {major}
                      <i className="pi pi-times" style={{ fontSize: "9px", cursor: "pointer" }} onClick={() => removeEducationMajor(major)} />
                    </span>
                  ))}
                </div>
              )}

              <span style={{ fontSize: "10px", color: "#9ca3af", marginTop: 4, display: "block" }}>Add one or more majors — resume must match any of them</span>
              <span style={{ fontSize: "10px", color: "#6b7280", marginTop: "5px", display: "block" }}>
                <i className="pi pi-info-circle" style={{ marginRight: "4px" }} /> Press <strong>Enter</strong> or click <strong>+</strong> to add the keyword before updating.{" "}
              </span>
            </FieldWrapper>

            <Divider style={{ borderColor: "rgba(255,255,255,0.15)", margin: "14px 0" }} />

            <FieldWrapper label="Education Level">
              <Dropdown value={filters.educationLevel} options={EDUCATION_LEVELS} onChange={(e) => set("educationLevel", e.value)} placeholder="Any" style={{ ...inputStyle, padding: "3px 6px" }} />
            </FieldWrapper>
          </AccordionTab>

          {/* ── 6. Salary ────────────────────────────────────────────────── */}
          {/* <AccordionTab
                        header={
                            <span style={{ fontSize: "12px", fontWeight: 700, color: "#4b0082" }}>
                                <i className="pi pi-dollar" style={{ marginRight: 6, color: "#9333ea" }} />
                                Salary
                            </span>
                        }
                    >
                        <FieldWrapper label="Salary Type">
                            <Dropdown
                                value={filters.salaryType}
                                options={SALARY_TYPE_OPTIONS}
                                onChange={(e) => set("salaryType", e.value)}
                                placeholder="Any"
                                style={{ ...inputStyle, padding: "3px 6px" }}
                            />
                        </FieldWrapper>

                        <div style={{ display: "flex", gap: "8px" }}>
                            <FieldWrapper label="Min ($)" error={null}>
                                <InputText
                                    value={filters.salaryMin}
                                    onChange={(e) => set("salaryMin", e.target.value.replace(/\D/g, ""))}
                                    placeholder="0"
                                    style={{ ...inputStyle, width: "100%" }}
                                />
                            </FieldWrapper>
                            <FieldWrapper label="Max ($)" error={errors.salaryMax}>
                                <InputText
                                    value={filters.salaryMax}
                                    onChange={(e) => set("salaryMax", e.target.value.replace(/\D/g, ""))}
                                    placeholder="0"
                                    style={{ ...inputStyle, width: "100%", borderColor: errors.salaryMax ? "#dc2626" : "#d1d5db" }}
                                />
                            </FieldWrapper>
                        </div>
                        {errors.salaryMax && (
                            <span style={{ fontSize: "10px", color: "#dc2626", display: "block", marginTop: "-8px", marginBottom: "8px" }}>
                                <i className="pi pi-exclamation-circle" style={{ marginRight: 3 }} />
                                {errors.salaryMax}
                            </span>
                        )}
                    </AccordionTab> */}
        </Accordion>
      </div>

      {/* ── Footer Buttons ─────────────────────────────────────────────────── */}
      <div style={{ borderTop: "1px solid #e5e7eb", padding: "12px 16px", display: "flex", gap: "8px", flexShrink: 0, background: "#fafafa" }}>
        <Button label="NEW SEARCH" className="p-button-outlined p-button-sm" style={{ flex: 1, fontSize: "11px", color: "#6b7280", borderColor: "#d1d5db" }} onClick={onNewSearch} />
        <Button label="CLEAR" className="p-button-outlined p-button-sm" style={{ flex: 1, fontSize: "11px", color: "#6b7280", borderColor: "#d1d5db" }} onClick={handleClear} />
        <Button label="UPDATE" className="p-button-sm" style={{ flex: 1, fontSize: "12px", backgroundColor: "#374151", border: "none" }} onClick={handleApply} />
      </div>
    </div>
  );
};

export default MonsterBooleanSearchFilter;
export { DEFAULT_FILTERS };
